<div class="not-found-container">
    <div class="not-found-content">
        <h1>{{code}}</h1>
        <h2>Oops! You are not authorized to access the requested resource</h2>
        <p>Please reauthenticate and try again</p>
        <a *ngIf="canGoBack()" (click)="goBack()" class="home-button">Go Back</a>
    </div>
</div>